module.exports = __webpack_public_path__ + "static/img/20260424001.8c6e282.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/20260424001.jpg
// module id = s+Wx
// module chunks = 0